import { toast } from "react-toastify";

export const notifySuccess = (messgae) => toast.success(messgae, { position: "bottom-right", });
export const notifyError = (messgae) => toast.error(messgae, { position: "bottom-right", });